





























































import {
	defineComponent,
	PropType,
	watchEffect,
} from '@vue/composition-api';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Group } from '@front-app/services/GroupsApi/GroupModel';
import { GroupMember } from '@front-app/services/UserApi/UserModel';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import LoaderState from '../LoaderState.vue';
import DenseUserList from '../cards/DenseUserList.vue';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		CtaButton,
		LoaderState,
		DenseUserList,
	},
	props: {
		group: {
			type: Object as PropType<Group>,
			required: true,
		},
		administrators: {
			type: Array as PropType<GroupMember[]>,
			required: true,
		},
		isLoadingAdministrators: Boolean,
	},
	setup(props) {
		watchEffect(() => {
			props.administrators.forEach(({ id }) => {
				UserAvatarStore.fetch(id);
			});
		});
		watchEffect(() => {
			trackGroupSimpleAction(props.group.id, GroupAuditAction.VIEW_GROUP_DETAILS_PAGE);
		});
		const getImage = (id: string) => UserAvatarStore.get(id);

		return {
			getImage,
			ButtonPalettes,
		};
	},
});
